import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import actions from '@store/actions';
import NewsComponent, { NewsProps } from '@components/article';
import { RootState } from '@store/types';

const mapStateToProps = (state: RootState) => ({
  configurator: state.configurator,
  content: state.content,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  configuratorActions: bindActionCreators(actions.configurator, dispatch),
  contentActions: bindActionCreators(actions.content, dispatch),
});

interface DNewsPropsProps extends NewsProps {}
const DNews: React.FC<DNewsPropsProps> = (props: DNewsPropsProps) => <NewsComponent {...props} />;

const NewsConnected = connect(
  mapStateToProps,
  mapDispatchToProps
)(DNews);

export default NewsConnected;
